import axios from '../axios'

export const termList = (data) => {
  return axios({
    url: '/con/manage/term/list',
    method: 'GET',
    data
  })
}
//新增学期排班
export const termSave = (data) => {
  return axios({
    url: '/con/manage/term/save',
    method: 'POST',
    type:'JSON',
    data
  })
}
//修改学期
export const termDetail = (data) => {
  return axios({
    url: '/con/manage/term/detail',
    method: 'POST',    
    data
  })
}
//查看学期排版table 详情
export const scheduleList = (data) => {
  return axios({
    url: '/con/manage/term/schedule/list',
    method: 'POST',    
    data
  })
}
//修改学期
export const termEdit = (data) => {
  return axios({
    url: '/con/manage/term/edit',
    method: 'POST',
    type:'JSON',
    data
  })
}
//添加学期下的课程
export const courseSave = (data) => {
  return axios({
    url: '/con/manage/term/course/save',
    method: 'POST',
    type:'JSON',
    data
  })
}
//编辑学期下的课程
export const courseEdit = (data) => {
  return axios({
    url: '/con/manage/term/course/edit',
    method: 'POST',
    type:'JSON',
    data
  })
}
//查询下拉列表
export const selectCurrentConfig = (data) => {
  return axios({
    url: '/con/manage/term/course/selectCurrentConfig',
    method: 'POST',    
    data
  })
}
//查询学期排版下的单元格详情
export const scheduleDetail = (data) => {
  return axios({
    url: '/con/manage/term/schedule/detail',
    method: 'GET',    
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/workforceManagement.js